module.exports = __webpack_public_path__ + "img/master-card.01695523.svg";